const routes = [
  {
    path: 'vuetifydateinput',
    name: 'vuetifydateinput',
    component: () => import(/* webpackChunkName: "vuetifydateinput" */ '@/modules/vuetifydateinput/index.vue')
  },
];

export default routes;